import React from "react";
import CustomTabs from "components/Shared/CustomTabs";
import CustomTabPanel from "components/Shared/CustomTabPanel";
import { useSearchParams } from "react-router-dom";
import { useGetNotesBySourceQuery } from "store/services/noteApi";
import { useVehicleHiringEntryDetailContext } from "contexts/VehicleHiringEntryDetailContext";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";
import NoteTab from "../../Note/Notetab";
import VehicleHiringEntryChangeLogs from "./VehicleHiringEntryChangeLogs";

const VehicleHiringEntryDetailTab = () => {
    const [searchParams] = useSearchParams();
    const activeTab = searchParams.get("tab") || "notes";
    const { vehicleHiringEntryDetail } = useVehicleHiringEntryDetailContext();

    const { data: notes } = useGetNotesBySourceQuery(
        {
            source: "VehicleHiringEntry",
            sourceRef: vehicleHiringEntryDetail?._id,
        },
        { skip: !vehicleHiringEntryDetail?._id }
    );

    const tabs = [
        { label: "Notes", value: "notes", badgeCount: notes?.length || 0 },
        { label: "Change Log", value: "changelog" },
    ];

    return (
        <>
            <CustomTabs tabs={tabs} activeTab={activeTab} />
            {vehicleHiringEntryDetail ? (
                <>
                    <CustomTabPanel activeTab={activeTab} value="notes">
                        <NoteTab
                            source="VehicleHiringEntry"
                            sourceRef={vehicleHiringEntryDetail._id}
                        />
                    </CustomTabPanel>
                    <CustomTabPanel activeTab={activeTab} value="changelog">
                        <VehicleHiringEntryChangeLogs
                            vehicleHiringEntryId={vehicleHiringEntryDetail._id}
                        />
                    </CustomTabPanel>
                </>
            ) : (
                <RowsSkeleton />
            )}
        </>
    );
};

export default VehicleHiringEntryDetailTab;